export const BRANCHDATA = "BRANCHDATA";
export const CURRENT_USER = "CURRENT_USER";
export const SERVICEDATA = "SERVICEDATA";
export const CARTDATA = "CARTDATA";
export const SERVICELIST = "SERVICELIST";
export const TIMESLOTS = "TIMESLOTS";
export const LOCATION = "LOCATION";
